export default "/images/vendor/flag-icon-css/flags/4x3/kz.svg?8e060ebaca712d1fea76cfc4e77acbf3";